import { AppThunk } from '../../../../store/types';
import { AuthManager } from '../../../../../common/utils/auth-manager';
import { ensureAnonymousSession, prepareAfterOpen } from '../../../../effects/prepareAfterOpen';
import { getAuthUser } from '../../../../store/general/selectors';
import { setAuthUserAction } from '../../../../store/general/actions';
import { ADMIN_PANEL_URL } from '../../../../../common/constants';
import { Navigator } from '../../../../effects/navigator';
import { resetModelsAction } from '../../../../store/models/actions';
import { getTargetLanguage } from '../../../../store/models/selectors';
import { UserRest } from '../../../../../common/rest/user/userRest';
import { EventsRouter } from '../../../../../common/events/eventsRouter';
import { Events } from '../../../../../common/events/types';
import { AuthUserEffects } from '../../../../effects/authUserEffects';
import { LoginPopupSelectors } from '../../../../store/loginPopup/selectors';
import { LangUtil } from '../../../../../common/utils/lang-util';

export class AccountButtonEvents {

  public static onSwitchAccount(
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const result = await AuthManager.switchAccount();
      if (result && result.authUser) {
        dispatch(resetModelsAction());
        dispatch(prepareAfterOpen(result.authUser, result.settings, result.appSettings));
        Navigator.openDefault();
      }
    }
  }

  public static onSignOut(
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const user = getAuthUser(getState());
      if (user) {
        const nativeLangCode = LangUtil.checkLangCode(navigator.language);
        let targetLangCode = getTargetLanguage(getState())?.code || 'en';
        if (nativeLangCode === targetLangCode) {
          targetLangCode = nativeLangCode === 'en' ? 'fr' : 'en';
        }

        try {
          await AuthManager.logout();
          dispatch(setAuthUserAction(null));
          dispatch(resetModelsAction());

          // re-enter as a fresh anonymous user so the initial "Please login" screen shows again
          await ensureAnonymousSession(targetLangCode, nativeLangCode, false);

          // Full load: with the cookies gone the server serves the static guest landing on `/`
          window.location.assign('/');
        } catch (e) {
          // A failure here would leave authUser null forever, stuck on CallApp's spinner - reload instead.
          console.log('sign out failed, reloading to recover', e);
          window.location.reload();
        }
      }
    }
  }

  public static onShowAdminPanel(): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      await UserRest.loginAdmin();
      window.open(ADMIN_PANEL_URL);
    }
  }

  public static onLoginAs(
    email: string
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const result = await AuthManager.loginByEmail(email);
      if (result && result.authUser) {
        dispatch(prepareAfterOpen(result.authUser, result.settings, result.appSettings));
        Navigator.openDefault();
      }
    }
  }

  public static onLogin(
  ): AppThunk {
    return async (
      dispatch,
      getState
    ): Promise<boolean> => {
      EventsRouter.trackEvent(Events.SIGN_IN_CLICKED);
      const result = await AuthUserEffects.loginProcess({
        newUserCallback: AuthUserEffects.newUserDefaultHandler,
        targetLangName: '',
        nativeLangName: '',
        disableNavigateOnLogin: true
      });
      const ret = !!result && !!result.authUser;
      if (ret) {
        if (!result.authUser.isNew) {
          const { onLogin } = LoginPopupSelectors.getLoginPopup(getState());
          if (onLogin) {
            onLogin();
          } else {
            // window.location.reload();
          }
        }
      }
      return ret;
    }
  }

}
